package fr.manyverse.app.presentation.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import fr.manyverse.app.infrastructure.datastore.UserPreferencesDataStore
import fr.manyverse.app.presentation.components.common_tabs.DiceTrayColor
import fr.manyverse.app.presentation.dice3d.DiceColor
import fr.manyverse.app.presentation.dice3d.DiceOneFace
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

/**
 * Préférences globales (cosmétiques) de la piste de dés : couleur du feutre, couleur des dés 3D
 * et image de la face « 1 ». Chargées au démarrage puis persistées à chaque changement, comme
 * [ThemeViewModel].
 */
class DiceTrayViewModel(
    private val userPreferencesDataStore: UserPreferencesDataStore
) : ViewModel() {

    private val _color = MutableStateFlow(DiceTrayColor.DEFAULT)
    val color: StateFlow<DiceTrayColor> = _color.asStateFlow()

    private val _diceColor = MutableStateFlow(DiceColor.DEFAULT)
    val diceColor: StateFlow<DiceColor> = _diceColor.asStateFlow()

    /** Null tant que l'utilisateur n'a rien choisi : le réglage d'univers fait alors foi. */
    private val _oneFace = MutableStateFlow<DiceOneFace?>(null)
    val oneFace: StateFlow<DiceOneFace?> = _oneFace.asStateFlow()

    init {
        viewModelScope.launch {
            userPreferencesDataStore.getDiceTrayColor()?.let { stored ->
                _color.value = DiceTrayColor.fromId(stored)
            }
            userPreferencesDataStore.getDiceColor()?.let { stored ->
                _diceColor.value = DiceColor.fromId(stored)
            }
            _oneFace.value = DiceOneFace.fromId(userPreferencesDataStore.getDiceOneFace())
        }
    }

    fun selectColor(color: DiceTrayColor) {
        _color.value = color
        viewModelScope.launch {
            userPreferencesDataStore.saveDiceTrayColor(color.id)
        }
    }

    fun selectDiceColor(color: DiceColor) {
        _diceColor.value = color
        viewModelScope.launch {
            userPreferencesDataStore.saveDiceColor(color.id)
        }
    }

    fun selectOneFace(face: DiceOneFace) {
        _oneFace.value = face
        viewModelScope.launch {
            userPreferencesDataStore.saveDiceOneFace(face.id)
        }
    }
}
